module.exports = __webpack_public_path__ + "img/7.70433390.png";